type Widths = {
  fullWidth: number;
  table: number;
  subscription: number;
  form: number;
};

declare module "@mui/material/styles" {
  interface Theme {
    widths: Widths;
  }
  interface ThemeOptions {
    widths: Widths;
  }
}

const widths: Widths = {
  fullWidth: 1920,
  table: 1600,
  subscription: 960,
  form: 720,
};

export default widths;
